import { FC, useEffect } from 'react'

import styled from 'styled-components'

import { InfluencerRegisterEnum } from 'src/Types/users'
import { CTAButton } from 'src/Components/Buttons/CTAButton'
import { creatorRegAuthorizationSuccessEvent } from 'src/Helpers/TagManager/CreatorsEvents'

import Status from '../Status'

import { UserDataInfo } from './UserDataInfo'

const StyledCTAButton = styled(CTAButton)`
  padding-left: 40px;
  padding-right: 40px;
`

interface LoginCreatorConnectedProps {
  status: InfluencerRegisterEnum
  setRegisterState: (state: InfluencerRegisterEnum) => void
}
export const LoginCreatorConnected: FC<LoginCreatorConnectedProps> = ({
  status,
  setRegisterState,
}) => {
  useEffect(() => {
    status === InfluencerRegisterEnum.CONNECTED &&
      creatorRegAuthorizationSuccessEvent()
  }, [status])

  if (status !== InfluencerRegisterEnum.CONNECTED) {
    return null
  }
  return (
    <>
      <Status step={1} />
      <UserDataInfo />

      <StyledCTAButton
        onClick={() => setRegisterState(InfluencerRegisterEnum.FORM)}
      >
        Continue
      </StyledCTAButton>
    </>
  )
}
